import { useSelector, useDispatch } from "react-redux";
import React, {
  Fragment,
  useState,
  useEffect,
  useLayoutEffect,
  useRef,
  createRef,
  forwardRef,
} from "react";
import { ToWords } from "to-words";
import Moment from "react-moment";
import {
  addOrderInfo,
  updateOrderInfoModeStore,
} from "./../../slice/orderSlice";
// import ReactToPrint from "react-to-print";

const Invoice = (props) => {
  const componentRef = useRef(null);
  // var totalAmount = 0;
  const [totalAmount, setTotalAmount] = useState(0);

  const dateNow = new Date();
  const current = new Date();
  const dateToday = `${current.getDate()}/${
    current.getMonth() + 1
  }/${current.getFullYear()}`;

  const toWords = new ToWords({
    localeCode: "en-IN",
    converterOptions: {
      currency: true,
      ignoreDecimal: false,
      ignoreZeroCurrency: false,
      doNotAddOnly: false,
      currencyOptions: {
        // can be used to override defaults for the selected locale
        name: "Taka",
        plural: "Taka",
        symbol: "tk",
        fractionalUnit: {
          name: "Poisa",
          plural: "Poisa",
          symbol: "",
        },
      },
    },
  });

  //*** Store */
  const dispatch = useDispatch();
  //Get state from store
  const {
    customerStore,
    customerInfoModeStore,
    customerGUIDStore,
    orderStore,
    orderInfoModeStore,
    orderGUIDStore,
    orderItemsWithMeasurementStore,
    isLoadingStore,
  } = useSelector((state) => state.order);

  useEffect(() => {
    // alert("useEffect");
    let totalAmountTmp = 0;
    props.orderProductItemStore.forEach((orderedProductItem, index) => {
      // alert("totalamound" +index+", "+ totalAmountTmp);
      totalAmountTmp =
        totalAmountTmp + orderedProductItem.qty * orderedProductItem.unitPrice;
    });

    setTotalAmount(totalAmountTmp);
    // alert("totalamound" + ", " + totalAmount);
  }, [props.orderProductItemStore]);

  return (
    <Fragment>
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div>
              <div className="table-responsive">
                <table style={{ width: "100%" }}>
                  <tr>
                    <td colSpan={"2"}>
                      <div
                        style={{
                          width: "100%",
                          fontWeight: "bolder",
                          fontSize: "24px",
                          textAlign: "center",
                          // border: "3px solid #F00",
                        }}
                      >
                        Libas Tailors
                      </div>
                      <div
                        style={{
                          width: "100%",
                          fontWeight: "bolder",
                          fontSize: "18px",
                          textAlign: "center",
                        }}
                      >
                        Invoice/Bill
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "70%" }}>
                      <div>
                        <b>Order Number:</b> <b>{props.orderStore?.orderID}</b>
                        <br />
                        <b>Customer Name:</b> {props.customerStore?.name}{" "}
                        <br />
                        <b>Phone no:</b> {props.customerStore?.cellNo} <br />
                        <b>Email:</b>{" "}
                        {props.customerStore?.email === "null"
                          ? ""
                          : props.customerStore?.email}{" "}
                        <b>Address:</b>{" "}
                        {props.customerStore?.address === "null"
                          ? ""
                          : props.customerStore?.address}{" "}
                        <br />
                      </div>
                    </td>
                    <td style={{ width: "30%" }}>
                      <div>
                        <b>Date:</b>
                        {/* {dateToday} */}
                        {
                          <Moment format=" Do MMMM YYYY, h:mm:ss a">
                            {dateNow}
                          </Moment>
                        }
                        <br />
                        <b>Created By:</b> Miraz
                      </div>
                    </td>
                  </tr>
                </table>
                <table
                  className="table table-bordered tableBorder"
                  style={{ border: "1px solid #000" }}
                >
                  <thead>
                    <tr style={{ border: "2px solid #000" }}>
                      <th style={{ textAlign: "center" }}>SI No.</th>
                      <th>Item Name</th>
                      <th>Item Invoice No</th>
                      <th style={{ textAlign: "center" }}>Quantity</th>
                      <th style={{ textAlign: "right" }}>Unit Price (tk)</th>
                      <th style={{ textAlign: "right" }}>Total (tk)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.orderProductItemStore.map(
                      (orderedProductItem, index) => {
                        return (
                          <>
                            <tr style={{ border: "2px solid #000" }}>
                              <th style={{ textAlign: "center" }}>
                                {index + 1}
                              </th>
                              <td>{orderedProductItem.name}</td>
                              <td>{orderedProductItem.orderDetailID}</td>
                              <td style={{ textAlign: "center" }}>
                                {orderedProductItem.qty}
                              </td>
                              <td style={{ textAlign: "right" }}>
                                {orderedProductItem.unitPrice}
                              </td>
                              <td
                                className="color-primary"
                                style={{ textAlign: "right" }}
                              >
                                {orderedProductItem.qty *
                                  orderedProductItem.unitPrice}
                              </td>
                            </tr>
                          </>
                        );
                      }
                    )}
                  </tbody>
                </table>
                <table style={{ width: "100%" }}>
                  <tr>
                    <td>
                      <table
                        style={{
                          width: "70%",
                          border: "1px solid #000",
                          padding: "5px",
                        }}
                      >
                        <tr style={{ outline: "thin solid" }}>
                          <td style={{ padding: "5px" }}>
                            <div>
                              <b>Previous Due (tk):</b> 0
                              <br />
                              <b>Sales (tk):</b> {totalAmount}
                              <br />
                              <b>Collected (tk):</b> {totalAmount}{" "}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ padding: "5px" }}>
                            <b>Net Outstanding (tk):</b> 0{" "}
                          </td>
                        </tr>
                      </table>
                    </td>
                    <td style={{ verticalAlign: "top" }}>
                      <table
                        style={{
                          float: "right",
                          width: "50%",
                          border: "1px solid #000",
                          padding: "5px",
                        }}
                      >
                        <tr style={{ outline: "thin solid" }}>
                          <td style={{ padding: "3px" }}>
                            <div>
                              <b>SubTotal (tk):</b>
                            </div>
                          </td>
                          <td style={{ padding: "3px", textAlign: "right" }}>
                            <div>{totalAmount}</div>
                          </td>
                        </tr>
                        <tr style={{ outline: "thin solid" }}>
                          <td style={{ padding: "3px" }}>
                            <div>
                              <b>Discount (tk):</b>
                            </div>
                          </td>
                          <td style={{ padding: "3px", textAlign: "right" }}>
                            <div>0</div>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
                <table style={{ width: "100%", marginTop: "7px" }}>
                  <tr>
                    <td style={{ width: "70%" }}>
                      <div>
                        <b>In word:</b> {toWords.convert(totalAmount)}
                        {/* {converter.toWords(1234.5)} */}
                      </div>
                    </td>
                    <td style={{ width: "20%" }}>
                      <div>
                        <b>Grand Total (tk):</b> {totalAmount}
                      </div>
                    </td>
                  </tr>
                </table>

                <table style={{ width: "100%", marginTop: "50px" }}>
                  <tr>
                    <td style={{ width: "70%" }}>
                      <div>
                        -----------------------
                        <br />
                        <b>Customer Signature</b>
                      </div>
                    </td>
                    <td style={{ width: "20%" }}>
                      <div>
                        -----------------------
                        <br />
                        <b>Authority Signature</b>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Invoice;
